// Evaluates a sum typed into a number field, e.g. "1+4", "40 - 8 + 2.5". Only numbers (decimals
// allowed) joined by + and -, with an optional leading sign; nothing else, so it is safe to run on
// whatever a user types (no eval). Returns the number, or null if the text is not a complete sum.
export function evaluateSum(text) {
  // Spaces are fine around the signs, not inside a number ("4 4" is rejected, not read as 44).
  const compact = String(text ?? '').trim().replace(/\s*([+-])\s*/g, '$1');
  if (!/^[+-]?(\d+\.?\d*|\.\d+)([+-](\d+\.?\d*|\.\d+))*$/.test(compact)) return null;

  let total = 0;
  for (const term of compact.match(/[+-]?(\d+\.?\d*|\.\d+)/g)) total += Number(term);
  return Number.isFinite(total) ? total : null;
}
